export const CALLBACK_DETAILS = ["15", "30", "45", "60", "0"]
